module.exports = __webpack_public_path__ + "img/018.3a5cf06d.png";